import React from 'react';
import { Box, CardContent, CardContentProps } from '@material-ui/core';

/**
 * A wrapper of CardContent to use in a non-draggable card for consistent alignment
 */
export const DraggableCardContent: React.FunctionComponent<CardContentProps> = ({ children, ...props }) => {
    return <Box component={CardContent} marginLeft={4} {...props}>{children}</Box>;
};
